import * as yup from "yup";

export const useChildValidation = () => {
  return yup.object({
    amka: yup.string().required("Το πεδίο ΑΜΚΑ είναι υποχρεωτικό"),
    firstName: yup.string().required("Το πεδίο Όνομα είναι υποχρεωτικό"),
    lastName: yup.string().required("Το πεδίο Επώνυμο είναι υποχρεωτικό"),
    dob: yup.object({
      datePickerFormatted: yup
        .string()
        .required("Το πεδίο Ημ/νία Γέννησης είναι υποχρεωτικό"),
    }),
    gender: yup.object({
      id: yup
        .number()
        .typeError("Το πεδίο Φύλο είναι υποχρεωτικό.")
        .required("Το πεδίο Φύλο είναι υποχρεωτικό.")
        .moreThan(0, "Το πεδίο Φύλο είναι υποχρεωτικό."),
    }),
  });
};
